import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { AuthActions } from "./auth.actions";
import { LoginUser } from "../models/auth";
import { UrlsConstants } from "src/app/core/constants/urls.constants";
import { Router } from "@angular/router";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";

export class AuthStateModel {
  public token: string;
  public userName: string;
  public user: string;
  public level: number;
  public isLoading: boolean;
  public error: string | null;
}

const defaults = {
  token: null,
  userName: null,
  user: null,
  level: null,
  isLoading: false,
  rolesPermisosGrupoResults: [],
  error: null,
};

@State<AuthStateModel>({
  name: 'auth',
  defaults,
})
@Injectable()
export class AuthState {
  constructor(
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private router: Router,
  ) {}

  @Action(AuthActions.Login)
  login(ctx: StateContext<AuthStateModel>, { payload }: AuthActions.Login) {
    ctx.patchState({ isLoading: true });
    const loginUser = this.getAppInfo(payload);
    return this.authenticationService.login(loginUser).subscribe({
      next: (res) => {
        ctx.dispatch(new AuthActions.LoginSuccess(res));
      },
      error: (error) => {
        ctx.dispatch(new AuthActions.LoginFailed(error))
      },
    });
  }

  @Action(AuthActions.LoginSuccess)
  onLoginSuccess(ctx: StateContext<AuthStateModel>, { jwt }: AuthActions.LoginSuccess) {
    this.authenticationService.setTokenInLocalStorage(jwt);
    ctx.patchState({
      token: jwt,
      isLoading: false,
      error: null,
    });

    ctx.dispatch(new AuthActions.SetUser());

    if (window.location.pathname == `/${UrlsConstants.LOGIN_PATH}`) {
      this.router.navigate([UrlsConstants.HOME_PATH]);        
    } else if(window.location.pathname == `/${UrlsConstants.MONITOR_PATH}/${UrlsConstants.LOGIN_PATH}`){
      this.router.navigate([UrlsConstants.MONITOR_PATH, UrlsConstants.HOME_PATH]);
    } else {
      this.router.navigate([window.location.pathname]);
    }
  }

  @Action(AuthActions.LoginFailed)
  onLoginFailure(
    ctx: StateContext<AuthStateModel>,
    { error }: AuthActions.LoginFailed
  ) {
    let errorMessage = '';
    if (error && error.status == 401) {
      errorMessage = 'login.usuarioIncorrecto';
    } else {
      errorMessage = 'login.error';
    }
    ctx.patchState({
      error: errorMessage,
      isLoading: false,
    });
  }

  @Action(AuthActions.LoginSGC1)
  loginSGC1(ctx: StateContext<AuthStateModel>, { loginRequest }: AuthActions.LoginSGC1) {
    ctx.patchState({ isLoading: true });
    return this.authenticationService.loginSgc1(loginRequest).subscribe({
      next: (res) => {
        ctx.dispatch(new AuthActions.LoginSuccess(res));
      },
      error: (error) => {
        ctx.dispatch(new AuthActions.LoginFailed(error))
      },
    });
  }

  @Action(AuthActions.SetUser)
  getUser(ctx: StateContext<AuthStateModel>) {
    const userName = this.authenticationService.getUserNameFromToken();
    const user = this.authenticationService.getUserFromToken();
    const level = this.authenticationService.getLevelFromToken();
    ctx.patchState({
      userName: userName,
      user: user,
      level: Number(level)
    })
  }

  @Action(AuthActions.Logout)
  logout(ctx: StateContext<AuthStateModel>) {
    ctx.setState(defaults);
    this.authenticationService.logout();
  }

  @Action(AuthActions.Error)
  onErrorOccurred(
    ctx: StateContext<AuthStateModel>,
    { error }: AuthActions.Error
  ) {
    ctx.patchState({
      error: error,
      isLoading: false,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  @Action(AuthActions.SetDefaultState)
  setDefaultState(
    ctx: StateContext<AuthStateModel>,
    {}: AuthActions.SetDefaultState
  ) {
    ctx.patchState(defaults);
  }

  private getTitle() {
    return this.localizationService.translate('auth.auth');
  }

  getAppInfo(payload: LoginUser) {
    const group = "grp_apps_sgc"
    const applicationName = "sgc.aramark.es"
    return {...payload, group: group, applicationName: applicationName}
  }
}


